<div class="warp">
    <div class="toggle-warp pointer" *ngIf="toggleState else toggleOff" (click)="toggle(false)">
        <div class="warp-circle">
            <svg-icon svgClass="svg-img-stroke-mini " src="/assets/images/options/warp-toggle-on.svg"></svg-icon>
        </div>
        <div class="circleT on">
            <svg-icon svgClass="svg-img-mini" src="/assets/images/options/toggle-on.svg"></svg-icon>
        </div>
    </div>
    <p *ngIf="isMenu" translate>questionMenu.requierdMini</p>
</div>

<ng-template #toggleOff>
    <div class="toggle-warp pointer" (click)="toggle(true)">
        <div class="warp-circle">
            <img src="/assets/images/options/warp-toggle-of.svg">
        </div>
        <div class="circleT of">
            <img src="/assets/images/options/toggle-off.svg">
        </div>
    </div>
</ng-template>